import {SleepAsync} from "js-vextensions";
import {store} from "../../Store";
import {remoteUserProcessesBridge, processId} from "./Bridge_RemoteUserProcesses";
import {InDesktop} from "./Bridge_Native";
import {GetLocalIPAddresses} from "./Bridge_Preload";

export function GetOwnInstanceInfo() {
	return {
		processId,
		ipAddress: InDesktop() ? GetLocalIPAddresses()[0] : null, // in Start_WebviewPreload.ts of lf-desktop
		port: 3502, // always on 3502, for the moment
		allowClientConnections: store.main.engine.config.allowClientConnections,
	} as AppInstanceInfo;
}
remoteUserProcessesBridge.RegisterFunction("BroadcastInstanceInformation", ()=>{
	//if (!store.main.engine.config.allowConnectionOfRemotes) return new Promise(()=>{}); // return a promise that never resolves (response would not be useful)
	//if (!store.main.engine.config.allowClientConnections) return;

	const instanceInfo = GetOwnInstanceInfo();
	remoteUserProcessesBridge.Call("CollectInstanceInformation", instanceInfo);
});

export class AppInstanceInfo {
	processId: string;
	ipAddress: string|n; // don't worry; only shared to instances where user is signed in
	port: number;
	allowClientConnections: boolean;
}
export class AppInstanceInfoHolder {
	instanceInfos: AppInstanceInfo[] = [];
}

var currentInstanceInfoHolder: AppInstanceInfoHolder|n = new AppInstanceInfoHolder();
remoteUserProcessesBridge.RegisterFunction("CollectInstanceInformation", instanceInfo=>{
	if (currentInstanceInfoHolder && currentInstanceInfoHolder.instanceInfos.find(a=>a.processId == instanceInfo.processId) == null) {
		currentInstanceInfoHolder.instanceInfos.push(instanceInfo);
	}
});

export async function GetRemoteInstanceInfos(timeout: number) {
	const infoHolder = new AppInstanceInfoHolder();
	currentInstanceInfoHolder = infoHolder;
	remoteUserProcessesBridge.Call("BroadcastInstanceInformation");
	await SleepAsync(timeout);
	currentInstanceInfoHolder = null;

	return infoHolder.instanceInfos;
}